<template>
  <div>
    <div v-if="value" @click="$emit('input', false)" class="z-20 fixed inset-0 w-full h-full cursor-pointer border">
      <div class="fixed w-full h-full opacity-75 bg-black"></div>
      <div class="flex flex-wrap sm:flex-no-wrap items-center justify-center h-full mx-10 lg:mx-0">
        <button v-if="images.length > 1" @click.stop="nav(-1)" class="z-30 text-gray-500 hover:text-white bg-gray-900 flex items-center px-6 pb-3 rounded-lg border border-gray-900 hover:border-gray-800 focus:outline-none shadow-lg">
          <span class="block text-bold text-6xl">&lt;</span>
        </button>
        <div class="lg:w-1/2 z-30 md:mx-10 px-2 md:px-12 md:py-5">
          <a :href="currentImage.img" target="_blank">
            <img class="block w-full object-cover rounded-lg shadow-lg" :src="currentImage.min">
          </a>
        </div>
        <button v-if="images.length > 1" @click.stop="nav(1)" class="z-30 text-gray-500 hover:text-white bg-gray-900 flex items-center px-6 pb-3 rounded-lg border border-gray-900 hover:border-gray-800 focus:outline-none shadow-lg">
          <span class="block text-bold text-6xl">&gt;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'images'],

  data() {
    return {
      index: 0,
    };
  },

  computed: {
    currentImage() {
      let max = this.images.length - 1;
      let i   = this.index % (max + 1);

      if (i < 0) i = max;

      return this.images[i];
    },
  },

  methods: {
    nav(offset) {
      this.index += offset;
    },
  },
}
</script>
